// Typeahead experiments
export const HA_TYPEAHEAD_LID_SEARCH = 'HA_TYPEAHEAD_LID_SEARCH';
export const VRBO_LANDING_EGUAS_TYPEAHEAD = 'VRBO_LANDING_EGUAS_typeahead';
export const VRBO_LANDING_NEARBY_DESTINATIONS =
    'VRBO_LANDING_nearbyDestinations_EGReco';
